import { checkCCM19Consent } from './check-ccm19-consent';

/**
 * Reads the GA4 Client ID from the `_ga` cookie, gated behind CCM19 consent.
 *
 * The `_ga` cookie looks like `GA1.1.1234567890.1234567890`; the client id is
 * everything after the first two segments. Returns an empty string when consent
 * has not been granted or the cookie is absent, so lead submission is never blocked.
 *
 * @returns {string}
 */
export function getGaClientId() {
    if (!checkCCM19Consent()) return '';

    const match = document.cookie.match(/(?:^|;\s*)_ga=([^;]+)/);
    if (!match) return '';

    const parts = match[1].split('.');
    if (parts.length < 4) return '';

    return parts.slice(2).join('.');
}
